import Product from "types/Product";
import tudoFarma from "../../assets/images/tudo-farma/colgate.png";
import { getClientData } from "../../services/auth";

const TUDOFARMA_OL = process.env["REACT_APP_TUDOFARMA_OL"];

interface FornecedorConfig {
  logo: string;
  url: string;
  olHomolog: string;
}

interface FornecedoresTudoFarma {
  enabled: boolean;
  [key: number]: FornecedorConfig;
}

const fornecedoresTudoFarma: FornecedoresTudoFarma = {
  enabled: process.env["REACT_APP_TUDOFARMA_ENABLED"] === "true",
  100: {
    logo: tudoFarma,
    url: process.env["REACT_APP_TUDOFARMA_COLGATE_URL"] || "",
    olHomolog: process.env["REACT_APP_TUDOFARMA_COLGATE_OL_HOMOLOG"] || "",
  },
};

function getToken(): string {
  const clientData = getClientData();
  if (!clientData) {
    throw new Error("Cliente não autenticado");
  }
  const { cd_cliente: cdCliente, cnpj } = clientData;
  return btoa(`codigool=${TUDOFARMA_OL}&cnpj=${cnpj}&usuariool=${cdCliente}`);
}

interface TudoFarmaProps {
  product: Product;
}

export const TudoFarma = ({
  product: { cd_fornecedor: cdFornecedor },
}: TudoFarmaProps) => {
  const fornecedorKey = parseInt(String(cdFornecedor), 10);

  if (!fornecedoresTudoFarma[fornecedorKey] || !fornecedoresTudoFarma.enabled) {
    return null;
  }

  const { logo, url, olHomolog } = fornecedoresTudoFarma[fornecedorKey];
  const token = olHomolog || getToken();

  return (
    <a href={`${url}${token}`} target="_blank" rel="noopener noreferrer">
      <img src={logo} alt="TudoFarma" />
    </a>
  );
};
